<script setup>
import content from "./install.json";

const faq = content.faq;
const cta = content.cta;
const packages = content.package_details.packages;

definePageMeta({
  layout: "laravel-layout",
});

useHead({
  title: content.meta_tags.title,
  meta: content.meta_tags.meta,
});

const visible = ref(false);

const installItem = ref("");

const openModal = (item) => {
  installItem.value = item;
  visible.value = true;
  console.log(item);
};

const isPaymentModalOpen = ref(false);

const openPaymentModal = () => {
  isPaymentModalOpen.value = true;
};
</script>

<template>
  <section class="text-center py10 px-4">
    <div class="max-w-screen-xl mx-auto px-4 lg:pt-10 lg:pb-16">
      <h1 class="font-bold">
        <WrGradientText>
          WordPress Installation & Setup Service
        </WrGradientText>
      </h1>
      <p class="text-lg tracking-[0.5px]">
        We will configure and install Wordpress on your web hosting account
        along with all necessary plugins and themes. You can contact us if you
        don't have any idea about Wordpress installation at all. We will do it
        for you and give you a responsive solution within your budgetary
        limitations too.
      </p>

      <div
        class="mb-8 text-left mt-8 rounded-2xl p-6 lg:p-16 md:p-10 bg-[linear-gradient(180deg,#f3f1f9,#fff)] shadow-[0_0_0_1px_#E4E2ED] dark:bg-[image:var(--bg-result-section)] hover:[box-shadow:0_.0625rem_.75rem_0_rgba(38,57,82,.2)] [box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,.08)] transition-all duration-500"
      >
        <!-- Title -->
        <h2
          class="text-2xl md:text-3xl font-extrabold mb-4 text-[#312852] dark:text-white"
        >
          About WordPress
        </h2>

        <!-- Description -->
        <p class="text-base md:text-lg tracking-[0.5px] leading-[1.8] mt-4">
          With more than 23 million websites in the world, WordPress is the most
          popular blogging platform and one of the top ten most used software
          worldwide. WordPress is a powerful tool that allows you to create your
          own website without any prior knowledge of design or coding. The
          friendly and intuitive user interface makes it easy for you to layout
          your content and change the look and feel of your site.
        </p>

        <!-- Subheading -->
        <p class="font-semibold mt-8 mb-6 text-base">
          Here's what you'll get when from our WordPress installation service
        </p>

        <!-- Feature Grid -->
        <ul
          class="grid md:grid-cols-3 sm:grid-cols-2 gap-x-8 gap-y-6 text-sm md:text-base"
        >
          <li
            v-for="(service, index) in packages"
            :key="index"
            @click="openModal(service)"
            class="cursor-pointer font-medium text-sm relative pl-6 before:content-['ℹ'] before:absolute before:left-0 before:top-[2px] before:bg-[#bad0da] dark:before:text-black before:text-white before:text-[0.75rem] before:w-[17px] before:h-[17px] before:rounded-full before:flex before:items-center before:justify-center before:mr-[6px]"
          >
            {{ service.title }}
          </li>
        </ul>

        <!-- CTA Button -->
        <div class="mt-8">
          <WrButton @click="openPaymentModal"> Purchase $29 </WrButton>
        </div>
      </div>
    </div>
  </section>

  <WrBannerCTA
    :heading="cta.title"
    :paragraph-text="cta.subheading"
    :button-text="cta.linkText"
  />

  <section class="py-6 lg:py-12">
    <div class="px-4 max-w-screen-xl mx-auto">
      <h2 class="font-bold lg:text-center">
        <WrGradientText append-class="!leading-[1]">
          {{ faq?.main_heading }}
        </WrGradientText>
      </h2>
      <p class="tracking-[0.5px] mb-14 mx-auto lg:px-20 text-lg lg:text-center">
        {{ faq.sub_text }}
      </p>
      <WrAccordion :Content="faq.content" />
      <div
        class="mt-6 bg-red-100/50 border-l-4 dark:border-white border-[#d50b00] dark:bg-[image:var(--bg-official-partner)] text-xs p-4 rounded lg:mx-4"
      >
        <p>
          <strong>Disclaimer:</strong> WordPress and the WordPress logo are
          trademarks of
          <NuxtLink
            to="https://wordpressfoundation.org/"
            target="_blank"
            class="underline hover:no-underline"
            >WordPress Foundation</NuxtLink
          >, used under license agreement.
        </p>
      </div>
    </div>
  </section>

  <section class="relative z-10 pb-8">
    <div class="max-w-screen-xl mx-auto px-4">
      <h2 class="text-center">
        <WrGradientText text="Trusted for excellence and efficiency" />
        <p class="text-lg text-[var(--foreground)]">
          Webreinvent is trusted by leading organisations to enhance their
          development and operational efficiency.
        </p>
      </h2>
      <WrTestimonialCardCarousel class="mt-12" />
      <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
        >View All</WrButton
      >
    </div>
  </section>

  <WrPackagePopup
    :is-open="visible"
    :item="installItem"
    @close="visible = false"
    @closeAndPaymentOpen="openPaymentModal"
  />

  <WrPaymentModal
    :isOpen="isPaymentModalOpen"
    @close="isPaymentModalOpen = false"
    :plan="'wordpress'"
    page="wordpress"
  />
</template>
